import { render, staticRenderFns } from "./Conteudo.vue?vue&type=template&id=3ec7e7e0&scoped=true"
import script from "./Conteudo.vue?vue&type=script&lang=js"
export * from "./Conteudo.vue?vue&type=script&lang=js"
import style0 from "./Conteudo.vue?vue&type=style&index=0&id=3ec7e7e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec7e7e0",
  null
  
)

export default component.exports